module.exports = __webpack_public_path__ + "static/leaves@1.5x-ced70d4afdeb7f72e9c42e5119a9d622.png";